<template>
  <b-modal
    title="Thêm tỉnh thành vào vùng"
    centered
    no-close-on-backdrop
    ref="modal"
    size="lg"
    hide-footer
  >
    <div class="box-form-result">
      <p class="color-gray-1">
        Tìm thấy {{ danhSachTinhThanhNoiBo.length }} kết quả
      </p>
      <DataTable
        :value="danhSachTinhThanhNoiBo"
        :loading="isLoadingTable"
        :selection.sync="selectedTinhThanh"
      >
        <Column
          field="id"
          headerStyle="width: 40px"
          header=""
          bodyStyle="text-align: center"
          bodyClass="select-column"
          selectionMode="multiple"
        >
        </Column>
        <Column
          field="stt"
          dataKey="stt"
          headerStyle="width: 40px"
          headerClass="p-2"
          header="STT"
          bodyStyle="text-align: center"
        >
          <template #filter> </template>
          <template #body="slotProps">
            <span>{{ slotProps.index + 1 }}</span>
          </template>
        </Column>
        <Column
          filterMatchMode="custom"
          field="tenTinhThanh"
          header="Tên tỉnh thành"
          headerStyle="minWidth: 200px"
        >
          <template #filter>
            <InputText
              type="text"
              class="p-column-filter"
              placeholder="Tìm kiếm"
              v-model="requestForm.name"
              @change="layDanhSachTinhThanh"
            />
          </template>
          <template #body="slotProps">
            <span>{{ slotProps.data.name }}</span>
          </template>
        </Column>

        <Column
          filterMatchMode="custom"
          field="maViTri"
          header="Mã vị trí"
          headerStyle="minWidth: 200px"
        >
          <template #filter>
            <InputText
              type="text"
              class="p-column-filter"
              placeholder="Tìm kiếm"
              v-model="requestForm.codeName"
              @change="layDanhSachTinhThanh"
            />
          </template>
          <template #body="slotProps">
            <span>{{ slotProps.data.codeName }}</span>
          </template>
        </Column>
        <Column
          filterMatchMode="custom"
          field="thaoTac"
          header="Thao tác"
          headerStyle="width: 100px"
        >
          <template #body="slotProps">
            <div class="text-center">
              <b-icon
                icon="plus-circle-fill"
                v-b-popover.hover.top="'Thêm tỉnh thành vào vùng'"
                class="cursor-pointer color-red ml-2 text-success"
                @click="chonTinhThanh(slotProps.data)"
              />
            </div> </template
        ></Column>
        <template #empty
          ><div class="text-center">Không có dữ liệu</div></template
        >
        <template #loading
          ><div class="text-center">Đang tải dữ liệu ...</div>
        </template>
      </DataTable>
    </div>
    <div style="text-align: center" class="float-right mt-4">
      <base-button
        :disabled="selectedTinhThanh.length === 0"
        button="Thêm mới"
        size="sm"
        class="btn search-information-btn mb-3 mr-2"
        variant="primary"
        @click="chonDanhSachTinhThanh()"
        >Tạo</base-button
      >
      <base-button
        button="Đóng"
        size="sm"
        class="btn search-information-btn mb-3 mr-2"
        variant="outline-secondary"
        @click="hideModal()"
        >Hủy
      </base-button>
    </div>
  </b-modal>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  name: "ModalThemTinhThanhVaoVung",
  data() {
    return { requestForm: {}, selectedTinhThanh: [], isLoadingTable: false };
  },
  props: {
    idsTinhThanhTrongVung: {
      type: Array,
      default: () => [],
    },
    idsAppend: { type: Array, default: () => [] },
  },
  computed: {
    ...mapGetters({
      danhSachTinhThanh: "dmTinhThanh/danhSachTinhThanhFree",
    }),
    danhSachTinhThanhNoiBo() {
      return this.danhSachTinhThanh.filter(
        (x) => !this.idsTinhThanhTrongVung.includes(x.id)
      );
    },
  },
  methods: {
    chonTinhThanh(tinhThanh) {
      this.$emit("themTinhThanh", [tinhThanh]);
      this.hideModal();
    },
    layDanhSachTinhThanh() {
      let payload = {
        ...this.requestForm,
        tinhThanhIds: this.idsAppend,
      };
      console.log(payload);
      this.isLoadingTable = true;
      this.$store
        .dispatch("dmTinhThanh/layDanhSachTinhThanhFree", {
          ...this.requestForm,
          tinhThanhIds: this.idsAppend,
        })
        .then(() => {
          this.isLoadingTable = false;
        });
    },
    chonDanhSachTinhThanh() {
      this.$emit("themTinhThanh", this.selectedTinhThanh);
      this.hideModal();
    },
    showModal() {
      this.requestForm = {};
      this.layDanhSachTinhThanh();
      this.$refs.modal.show();
    },
    hideModal() {
      this.selectedTinhThanh = [];
      this.$refs.modal.hide();
    },
  },
};
</script>